<template>
  <div>
    <v-main>
      <ChildRecordsContainer />
    </v-main>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import ChildRecordsContainer from '@/container/records/ChildRecordsContainer.vue';

export default defineComponent({
  components: {
    ChildRecordsContainer,
  },
});
</script>
